import React from 'react';
import './BbExplanation.css';

class Explanation extends React.Component {
  shouldComponentUpdate(nextProps)
  {
    if (nextProps.wikiItemId !== this.props.wikiItemId) {
      return true;
    }
    if (nextProps.wikiExplanationJson !== this.props.wikiExplanationJson) {
      return true;
    }
    return false;
  }

  render() {
    console.log('*** EXPLANATION ***');
    let descriptionEN = '';
    let labelEN = '';
    let myAliases = '';
    const j = this.props.wikiExplanationJson !== undefined ? this.props.wikiExplanationJson : [];
    const { wikiItemId } = this.props;

    try {
      // labelEN = j.entities[wikiItemId].labels.en.value !== undefined ? j.entities[wikiItemId].labels.en.value : '';
      labelEN = j.wikiresponse.entities[wikiItemId].labels.en.value !== undefined ? j.wikiresponse.entities[wikiItemId].labels.en.value : 'NO LABEL';

      // descriptionEN = j.entities[wikiItemId].descriptions.en.value !== undefined ? j.entities[wikiItemId].descriptions.en.value : '';
      descriptionEN = j.wikiresponse.entities[wikiItemId].descriptions.en.value !== undefined ? j.wikiresponse.entities[wikiItemId].descriptions.en.value : 'NO DESCRIPTION';

      // let aliasesArray = j.entities[wikiItemId].aliases.en !== undefined ? j.entities[wikiItemId].aliases.en : [];
      const aliasesArray = j.wikiresponse.entities[wikiItemId].aliases.en !== undefined ? j.wikiresponse.entities[wikiItemId].aliases.en : [];

      for (let index = 0; index < aliasesArray.length; index += 1) {
        const element = aliasesArray[index].value;
        if (index === 0) {
          myAliases += element;
        } else {
          myAliases = `${myAliases}; ${element}`;
        }
      }
    } catch (error) {
      console.log(`ERROR: ${error}`);
    }

    return (
      <div className="my-4">
        <div className="center">
          <div className="fw-normal fs-5">{descriptionEN}</div>
          <div className="fw-bold fs-5">{labelEN}</div>
          <div>
            <span className="text-primary fw-bold">Aliases: </span>
            <span className="fw-bold fst-italic">
              {' '}
              {myAliases}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Explanation;
